import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-avisodeprivacidad',
  templateUrl: './avisodeprivacidad.component.html',
  styleUrls: ['./avisodeprivacidad.component.scss']
})
export class AvisodeprivacidadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
